import HotelPlaceholderImage from 'assets/hotel-placeholder.svg';

/**
 * A simple image component that displays an image with a fallback to a placeholder.
 * If the image fails to load, it will also display a placeholder image.
 */
const Image = ({
  src,
  alt = 'Image',
  className = 'size-full object-cover',
}: {
  src?: string;
  alt: string;
  className?: string;
}) => (
  <img
    src={src || HotelPlaceholderImage}
    alt={alt}
    className={className}
    onError={(error) => {
      error.currentTarget.src = HotelPlaceholderImage; // Fallback to placeholder image
      error.currentTarget.onerror = null; // Prevent infinite loop
    }}
  />
);

export default Image;
